import { Root as DealSummaryRoot } from '@makemydeal/activities-request-proposal';
import { ShowroomCardContainer } from '@makemydeal/dr-sales-checkin-components';
import { routingConfig } from '@makemydeal/dr-sales-checkin-types';
import { useDealSummaryPdfRequired } from '../../../hooks/useDealSummaryPdfRequired';
import { useHasDealSummaryLoaded } from '../../../hooks/useHasDealSummaryLoaded';
import { useShowroomLoadingIndicatorDisappearsTelemetry } from '../../../hooks/useShowroomLoadingIndicatorDisappearsTelemetry';

const DealSummary = () => {
    const hasLoaded = useHasDealSummaryLoaded();
    const dealSummaryPdfRequired = useDealSummaryPdfRequired();
    useShowroomLoadingIndicatorDisappearsTelemetry('SC:DealSummaryLoadingIndicatorDisappears', hasLoaded, {
        dealSummaryPdfRequired
    });

    return (
        <ShowroomCardContainer>
            <DealSummaryRoot baseRoute={routingConfig.DEAL_SUMMARY} />
        </ShowroomCardContainer>
    );
};

export default DealSummary;
